import(/* webpackMode: "eager" */ "/root/hcs_admin/src/app/(auth)/forgot-password/page.tsx");
